// extracted by mini-css-extract-plugin
module.exports = {"summary":"ServicesServiceHeader_summary__G_Ts8","search-fade-in":"ServicesServiceHeader_search-fade-in__lwuLh"};